export const addApostrophes = (value: string | number | undefined) => {
  if (!value) {
    return '';
  }

  return `'${value}'`;
};
